import React from 'react';
import PropTypes from 'prop-types';

const AccountLayout = ({
  children,
  img = '/images/background-account-1.svg',
  imgStyle = {}
}) => {
  return (
    <div className="account-layout">
      <div>
        <img
          src="/images/background-fill.svg"
          alt="Fond de l'image"
        />
        <img
          src={img}
          alt="Illustration de connexion"
          className="background-account"
          // eslint-disable-next-line no-restricted-syntax
          style={imgStyle}
        />
      </div>

      <div className="logo">
        <img src="/images/FASST_Flexi_Couleur.svg" alt="Logo Flexidocs"/>
      </div>

      <div className="account-layout-body">
        {children}
      </div>
    </div>
  );
};

AccountLayout.propTypes = {
  img: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func
  ]).isRequired,
  imgStyle: PropTypes.object
};

export default AccountLayout;
